export class RequestDetails {
  constructor(
    public readonly name: string,
    public readonly email: string,
  ) {}
}
